<script>
import { AlertComponent as Alert } from 'vue-elder-alert'
import { ButtonComponent } from 'vue-elder-button'
import Tabs from '@/components/Tabs'
import Providers from './Providers'

export default {
  props: {
    domain: String,
  },
  data() {
    return {
      provider: 'Other',
      status: false,
      loading: false,
    }
  },
  computed: {
    providers() {
      const isNO = this.$store.state.enums.Region.value === 'NO'
      return [
        isNO ? { id: 'Domeneshop', label: 'Domeneshop' } : null,
        isNO ? { id: 'Webhuset', label: 'Webhuset' } : null,
        { id: 'Other', label: this.$t('other') },
      ].filter(Boolean)
    },
    pointers() {
      if (!this.domain) return []
      const parts = this.domain.split('.')

      if (parts.length === 2)
        return [
          { type: 'CNAME', value: `www.${this.domain}`, target: window.location.hostname },
          { type: 'A', value: this.domain, target: '46.101.173.122' },
        ]

      if (parts.length === 3 && parts[0] === 'www')
        return [
          { type: 'CNAME', value: `${this.domain}`, target: window.location.hostname },
          { type: 'A', value: parts.slice(1).join('.'), target: '46.101.173.122' },
        ]

      return [{ type: 'CNAME', value: this.domain, target: window.location.hostname }]
    },
  },
  methods: {
    checkDns() {
      this.loading = true

      fetch(`/api/dns/verify?domain=${this.domain}`)
        .then(res => res.json())
        .then(({ status }) => (this.status = status))
        .finally(() => (this.loading = false))
    },
  },
  watch: {
    domain: {
      handler: 'checkDns',
      immediate: true,
    },
  },
  components: {
    Alert,
    Tabs,
    ButtonComponent,
    ...Providers,
  },
}
</script>

<template>
  <div class="dns-instructions">
    <div v-if="!status" class="dns-instructions__status row g-2 mb-2">
      <Alert theme="warning" class="grow-1">{{ $t('validDnsSetupMessage') }}</Alert>
      <ButtonComponent :label="$t('retry')" :icon="['fal', 'sync-alt']" :loading="loading" @click="checkDns" />
    </div>

    <div class="dns-instructions__content">
      <p class="mt-0 pt-0">{{ $t('dnsProviderSelectionTitle') }}</p>

      <Tabs v-model="provider" :items="providers">
        <template v-slot:[provider]>
          <component :is="provider" :pointers="pointers" class="dns-instructions__provider"></component>
        </template>
      </Tabs>

      <p>{{ $t('dnsProviderSelectionDescription') }}.</p>
    </div>
  </div>
</template>

<style lang="scss">
.dns-instructions {
  &__content {
    padding: 1.5rem;
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius);
  }

  .alert {
    &__content {
      font-weight: bold;

      &:before {
        border-radius: var(--border-radius);
      }
    }
  }

  &__provider {
    li {
      padding-block: 0.1em;
    }
  }

  .tabs__tab {
    padding-top: 0;
  }

  .tabs__details a {
    text-decoration: underline;
  }
}
</style>
